"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentCell = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const comment_cell_styles_1 = require("./comment-cell.styles");
const table_cell_styles_1 = require("../partials/table-cell.styles");
const icons_1 = require("../../../../../icons");
const CommentCell = ({ total = 0, onCommentClick }) => (react_1.default.createElement(table_cell_styles_1.StyledIconTableCell, { align: "left" }, react_1.default.createElement(comment_cell_styles_1.StyledCommentContainer, null, react_1.default.createElement(material_1.IconButton, { disableRipple: true, size: "small", onClick: onCommentClick }, react_1.default.createElement(icons_1.CommentIcon, { fill: ui_components_1.baseColors.primaryBlueMed400 })), total)));
exports.CommentCell = CommentCell;
exports.default = exports.CommentCell;
